import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import CONFIG from '../config';

export const useCurrentPath = () => {
  const { i18n } = useTranslation();
  const { asPath } = useRouter();

  const origin = useMemo(() => {
    const langPrefix = i18n.language === 'ru' ? 'ru.' : '';
    return `${CONFIG.protocol}://${langPrefix}${CONFIG.host}`;
  }, [i18n.language]);

  return { origin, currPath: origin + asPath };
};
